/**
 * 現場未選択の場合にセットする placeNodeUuid
 *
 * NOTE:
 * harami_mobile だと、現場未所属の場合の場合に限り現場未選択でもレポートを開始→保存出来る。
 * その仕様を踏襲するために定義している。
 */
export const unselectedPlaceNodeUuid = 'unselected-place-node-uuid'
